export { default, getServerSideProps } from '@/entries/BranchOffice';
